import React from 'react';

export const BrandsLoader: React.FC = React.memo(() => {
    return <React.Fragment></React.Fragment>;
});
